<div class="error-page">
    <h3>Page not found</h3>
    <p>The page you're looking for doesn't exist or may have moved.</p>
    <tools-button routerLink="/">Go to Home</tools-button>
</div>
